<!-- <ngx-sign-pdf [pdfUrl]="url" [exportPdf]='exportPdf' [exportSignatures]='exportSignatures' (pdfBase64Url)='getPdfUrl($event)' (signaturesList)='getSignaturesList($event)' [signatureColors]="colorsList" ></ngx-sign-pdf> -->


<!-- <app-side-nav 
  [sidenavTemplateRef]="navContent"
  [direction]="'left'" 
  [navWidth]="280" 
  [duration]="0.5"></app-side-nav> -->
<div class="main-container">
  <!-- <app-header></app-header> -->
  <!-- <h1>testing 1</h1>
  <h1>testing 2</h1>
  <h1>testing 3</h1> -->
  <section>
    <router-outlet></router-outlet>
  </section>
</div>

<!-- <ng-template #navContent>
  <app-side-nav-content></app-side-nav-content>
</ng-template> -->
